module.exports = "/images/badge_status_no_protection.png?5faeab4529a194a39d8766282a675a8c";